import {useSettingsQuery} from '@settings/modules/common/providers'
import {useUrlParam} from '@settings/modules/routing'

export const useUnits = () => {
  return useSettingsQuery('units', [])
}

export const useKpiUnits = (kpiId: number) => {
  const plantCode = useUrlParam('plantCode')
  return useSettingsQuery('kpiUnits', [plantCode, kpiId])
}
